import { useParams } from '@tanstack/react-router'

import { ServicePageShell } from '@/screens/ServicePageShell'
import { JobDetailsScreen } from '@/screens/JobDetailsScreen'
import { formatRelativeDateTime } from '@/lib/relativeDateTime'
import { useJobDetails } from '@/screens/useJobDetails'

export function JobDetailsScreenContainer() {
  const serviceId = useParams({ from: '/jobs/$id', select: (p) => p.id })
  const details = useJobDetails(serviceId)

  if (details.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Job details</h1>
          <p className="text-sm text-slate-600">Loading job…</p>
        </main>
      </div>
    )
  }

  if (details.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Job details</h1>
          <p className="text-sm text-slate-600">
            Unable to load job details right now.
          </p>
        </main>
      </div>
    )
  }

  if (details.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Job details</h1>
          <p className="text-sm text-slate-600">
            Job not found. Check the link or return to the jobs list.
          </p>
        </main>
      </div>
    )
  }

  const displayId = details.screenProps.publicId ?? details.screenProps.serviceId

  return (
    <ServicePageShell
      serviceTypeLabel="Job"
      serviceId={displayId}
      customerName={details.screenProps.customerName}
      customerId={details.screenProps.customerId}
      customerPublicId={details.screenProps.customerPublicId}
      scheduledAtLabel={formatRelativeDateTime(details.screenProps.createdAt)}
      initialIssue={details.screenProps.fault}
      activeTab="details"
      basePath="/jobs/$id"
      currentStatus={details.screenProps.status}
      statusChanges={details.screenProps.statusChanges}
      getAuthorDisplayName={details.screenProps.getAuthorDisplayName}
    >
      <JobDetailsScreen {...details.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
